import { render, staticRenderFns } from "./review.vue?vue&type=template&id=e28aae6e&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=e28aae6e&lang=less&scoped=true&"
import style1 from "./review.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28aae6e",
  null
  
)

export default component.exports